module.exports = __webpack_public_path__ + "static/absorb_elements-8931067d538e3fda78d3818bc6b15491.jpg";